import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=fece2146&scoped=true&"
import script from "./CustomTable.js?vue&type=script&lang=js&"
export * from "./CustomTable.js?vue&type=script&lang=js&"
import style0 from "./CustomTable.vue?vue&type=style&index=0&id=fece2146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fece2146",
  null
  
)

export default component.exports